import { db, auth, functions, messaging } from '@/fire'

let userSubcription
let companySubscription
let companyNameSubscription
let messageSubscription
let tokenSubscription

const userStore = {
  namespaced: true,
  state: {
    isLoggedIn: false,
    authUser: null,
    data: null,
    roles: null,
    company: null,
    message: null,
  },
  mutations: {
    authUser (state, authUser) {
      if (authUser) {
        state.isLoggedIn = authUser.uid
        state.authUser = authUser
      } else {
        if (userSubcription) userSubcription()
        if (companySubscription) companySubscription()
        if (companyNameSubscription) companyNameSubscription()
        state.isLoggedIn = false
        state.authUser = null
        state.data = null
        state.roles = null
        state.company = null
      }
    },
    roles (state, roles) {
      state.roles = roles
    },
    user (state, user) {
      state.data = user
    },
    company (state, company) {
      state.company = company
    },
    message (state, msg) {
      state.message = msg ? {
        title: msg.title || '',
        body: msg.body || '',
      } : null
    },
  },
  actions: {
    authChanged ({ commit, dispatch, state }, authUser) {
      commit('authUser', authUser)
      if (authUser) {
        /* Populate Roles */
        authUser.getIdTokenResult().then((userToken) => {
          commit('roles', userToken.claims)
          state.roles = userToken.claims
        })

        /* Load user object */
        if (userSubcription) userSubcription()
        userSubcription = db.collection('users').doc(authUser.uid).onSnapshot((snap) => {
          if (snap.exists) {
            const user = snap.data()
            if (user.active) {
              user.id = snap.id
              user.ref = snap.ref
              commit('user', user)

              let companyRef = user.company
              if (!companyRef && user.companies) {
                const cId = Object.keys(user.companies).pop()
                if (cId) companyRef = db.collection('companies').doc(cId)
              }
              dispatch('loadCompany', companyRef)
            }
          }
        }, (err) => {
          commit('user', null)
          console.warn({ type: 'warning', message: `users: ${err.message}` })
        })
      }
    },
    loadCompany ({ commit, dispatch, state }, companyRef) {
      if (companySubscription) companySubscription()
      if (companyRef) {
        companySubscription = companyRef.onSnapshot((snap) => {
          if (snap.exists) {
            if (companyNameSubscription) companyNameSubscription()
            const company = snap.data()
            company.id = snap.id
            company.ref = snap.ref
            if (company.owner && company.owner.id !== state.isLoggedIn) {
              dispatch('checkMessages')
            }
            commit('company', company)
          } else {
            commit('company', null)
          }
        }, () => {
          commit('company', null)
          dispatch('loadCompanyName', companyRef.id)
        })
      } else {
        commit('company', null)
      }
    },
    loadCompanyName ({ commit }, companyId) {
      if (companyNameSubscription) companyNameSubscription()
      companyNameSubscription = db.collection('cnames').doc(companyId).onSnapshot((snap) => {
        if (snap.exists) {
          const company = snap.data()
          company.id = snap.id
          company.ref = snap.ref
          commit('company', company)
        } else {
          commit('company', null)
        }
      }, (err) => {
        console.warn(err.message)
      })
    },
    setDefault ({ state }, companyRef) {
      if (state.data && state.data.ref) {
        state.data.ref.update({
          company: companyRef,
        })
      }
    },
    logout () {
      return auth.signOut()
    },
    joinCompany (store, code) {
      const joinCompany = functions.httpsCallable('joinCompany')
      return joinCompany({ code })
    },
    leaveCompany (store, companyId) {
      const leaveCompany = functions.httpsCallable('leaveCompany')
      return leaveCompany({ companyId })
    },
    checkMessages ({ commit }) {
      if (!messaging) return
      if (messageSubscription) messageSubscription()
      messageSubscription = messaging.onMessage((payload) => {
        commit('message', payload)
      })
    },
    checkToken ({ dispatch, state }) {
      if (!messaging || tokenSubscription || !state.company) return
      if (!state.company.owner || state.company.owner.id !== state.isLoggedIn) return
      messaging.getToken().then((currentToken) => {
        if (currentToken) {
          if (state.company.fcm !== currentToken) {
            state.company.ref.update({
              fcm: currentToken,
            })
          }
          tokenSubscription = messaging.onTokenRefresh(() => {
            messaging.getToken().then((refreshedToken) => {
              state.company.ref.update({
                fcm: refreshedToken,
              })
            }).catch((err) => {
              console.warn('Unable to retrieve refreshed token ', err)
              tokenSubscription = true
            })
          })
        } else {
          messaging.requestPermission().then(() => {
            dispatch('checkToken')
          }).catch((err) => {
            console.warn('Unable to retrieve refreshed token ', err)
            tokenSubscription = true
          })
        }
      }).catch((err) => {
        console.warn('Unable to retrieve refreshed token ', err)
        tokenSubscription = true
      })
    },
  },
}

export default userStore
